<template>
  <div class="my-order-box" ref="main">

    <!--tabstools-->
    <van-tabs color="#A9936B" id="IDTabHeader" v-model="selectedTagIndex" @click="tabItemClick" animated line-height="2" :swipe-threshold="tabsNum" title-active-color="red">
      <van-tab v-for="(item ,index) in tabs" :key="index" :title="item.title"></van-tab>

    </van-tabs>
    <div v-if="selectedTagIndex != 4">
      <!--列表项-->
      <div v-if="!isLoadingIcon">
        <div class="list-box" v-if="list.length>0">
          <van-pull-refresh class="listContainer" v-model="isLoading" @refresh="onRefresh" success-text="刷新成功">
            <ordercell @updataList="updataListEvent" :info="item" v-for="(item,index) in list" :key="index" @click="orderDetail"></ordercell>
          </van-pull-refresh>
        </div>
        <div class="NODataContainer" v-else>
          <img width="100%" src="../../assets/index/no_data.png" alt="">
          <div class="no-data">暂无数据</div>
        </div>
      </div>
      <van-loading v-else type="spinner" />

    </div>
    <div v-else>
      <div v-if="myCommentsListUi.length !=0" class="list-box">
        <van-list v-model="loadingF" :immediate-check="false" :finished="finishedF" finished-text="没有更多了" @load="onLoad" :offset="1">

          <div class="has-comments" v-for="(item,index) in myCommentsListUi" :key="index">
            <div class="has-comments-top">
              <img class="user-tx" :src="item.comment.avatar" alt="">
              <div class="user-box">
                <div class="user-name">{{item.comment.nickname}}</div>
                <van-rate v-model="item.comment.star" readonly />
              </div>
              <div class="update-time">{{item.comment.updateTime}}</div>
            </div>
            <van-grid :column-num="3" :gutter="5">
              <img class="content-pic" v-for="(pic,idx) in item.comment.picUrls" :key="idx" :src="pic" alt="" srcset="">

            </van-grid>
            <div class="comment-content">
              {{item.comment.content}}
            </div>
            <goodscell class="goodsCell" :isShowBtn="false" :info="item">
            </goodscell>
          </div>
        </van-list>
      </div>
      <div v-else>
        <img width="100%" src="../../assets/index/no_data.png" alt="">
        <div class="no-data">暂无数据</div>
      </div>
    </div>

    <div class="goback-page" @click="navToPerson">
      <!-- <van-icon name="arrow-left" /> -->
    </div>
  </div>
</template>



<script>
import userInfoPanel from "@/components/userInfoPanel";
import ordercell from "../../components/ordercell";
import { orderList, getUserCommentList } from "@/api/index";
import { Dialog } from "vant";
import goodscell from "../../components/goodscell";

export default {
  name: "myorders",
  components: {
    userInfoPanel,
    ordercell,
    goodscell,
  },
  data() {
    return {
      tabs: [
        { title: "全部" },
        { title: "待付款" },
        { title: "待发货" },
        { title: "待收货" },
        { title: "已评价" },
      ], //顶部tablist
      selectedTagIndex: this.$route.params.activeTag, //初始化被选中的tabs
      tabsNum: 5, //max tabs items

      isLoadingIcon: true,
      list: [], //数据源
      isLoading: false,
      myCommentsListUi: [],
      loadingF: false,
      finishedF: false,
      coupondataInfo: {
        showType: 1,
        page: 1,
        size: 10,
      },
    };
  },
  mounted() {
    //设置列表项的高度
    if (sessionStorage.getItem("orderIndex")) {
      this.selectedTagIndex = sessionStorage.getItem("orderIndex");
      setTimeout(() => {
        sessionStorage.removeItem("orderIndex");
      }, 1000);
    } else {
      this.selectedTagIndex = parseInt(this.$route.params.activeTag);
    }
  },
  watch: {
    $route: {
      handler() {
        console.log(this.$route);
        if (this.$route.name === "我的订单") {
          this.list = [];
          this.getOrderList(this.selectedTagIndex);
          window.addEventListener("scroll", this.handleScrollPerson, true);
          if (this.$refs.main && this.$route.meta.scrollTop) {
            this.$refs.main.scrollTop = this.$route.meta.scrollTop;
          }
        } else {
          window.removeEventListener("scroll", this.handleScrollPerson);
        }
      },
      immediate: true,
    },
  },
  destroyed() {
    //移除当前页面的监听，App不能重复添加监听
    window.removeEventListener("scroll", this.handleScrollPerson);
  },
  methods: {
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        const nextPaging = {
          showType: 1,
          page: this.coupondataInfo.page + 1,
          size: 10,
        };
        this.coupondataInfo = nextPaging;
        this.getMyComments(this.coupondataInfo);
      }, 500);
    },
    updataListEvent() {
      this.list = [];
      this.isLoadingIcon = true;

      this.getOrderList(this.selectedTagIndex);
    },
    navToPerson() {
      sessionStorage.setItem("selectIdx", 4);
      this.$route.meta.keepAlive = false;
      this.$router.push("/person");
    },
    handleScrollPerson() {
      if (
        this.$route.name === "我的订单" &&
        this.$refs.main.scrollTop &&
        this.$route.meta.scrollTop
      ) {
        this.$route.meta.scrollTop = this.$refs.main.scrollTop;
      }
    },
    getOrderList(type) {
      if (type == 4) {
        const paging = {
          showType: 1,
          page: 1,
          size: 10,
        };
        getUserCommentList(paging).then((res) => {
          console.log(res);
          if (res.data.errno == 0) {
            console.log(res.data.data.list);
            // this.list = res.data.data.list;
            this.myCommentsListUi = this.myCommentsListUi.concat(
              res.data.data.list
            );
            this.loadingF = false;
            // // 数据全部加载完成
            if (this.myCommentsListUi.length == res.data.data.count) {
              this.finishedF = true;
            }
          } else if (res.data.errno == 501) {
            Dialog.alert({
              title: "提示",
              message: res.data.errmsg,
            }).then(() => {
              // on close
              this.$router.push("/login");
            });
          } else {
            Dialog.alert({
              title: "提示",
              message: res.data.errmsg,
            });
          }
        });
      } else {
        orderList(type).then((res) => {
          if (res.data.errno == 0) {
            this.list = res.data.data.data;
            this.list.forEach((item) => {
              item.uiactualPrice = item.actualPrice.toFixed(2);
            });
            this.isLoadingIcon = false;
          } else if (res.data.errno == 501) {
            Dialog.alert({
              title: "提示",
              message: "登录已过期，请重新登录",
            }).then(() => {
              this.$router.push("/login");
            });
          }
        });
      }
    },
    orderDetail(data) {
      sessionStorage.setItem("orderIndex", this.selectedTagIndex);
      this.$route.meta.keepAlive = true;

      this.$router.push({
        path: "/myorderdetail",
        query: {
          id: data.id,
        },
      });
    },

    tabItemClick(index) {
      this.list = [];
      this.isLoadingIcon = true;
      this.selectedTagIndex = index;
      this.loadingF = false;
      this.finishedF = false;
      this.myCommentsListUi = [];
      this.coupondataInfo.page = 1;
      this.getOrderList(index);
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        this.isLoadingIcon = true;

        // 清空列表数据
        this.list = [];
        this.getOrderList(this.selectedTagIndex);
        this.finished = false;
      }, 500);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.van-loading {
  margin-top: 10rem;
}
.goback-page {
  // background: #fff;
  position: fixed;
  top: 0;
  left: 2rem;
  z-index: 4;
  height: 6rem;
  width: 5rem;
  display: flex;
  align-items: center;
  font-size: 2.3rem;
}
.my-order-box {
  height: 100%;
  /*控制底部滚动*/
  // overflow-y: hidden;
  overflow-y: scroll;

  background: #f4f4f4;
}
.listContainer {
  width: 100%;
  padding: 0 0.9rem;
  box-sizing: border-box;
  background-color: transparent;
  // overflow-y: scroll;
}
/deep/ .van-list {
  margin-bottom: 10rem;
}
.NODataContainer {
  text-align: center;
  font-size: 1.4rem;
  font-weight: bold;
  height: 100%;
  margin: 0 auto;
  position: fixed;
  width: 100%;
}
.list-box {
  box-sizing: border-box;
  padding-top: 4.4rem;
  height: calc(100% - 44px);
  width: 100%;
  margin: 0 auto;
}
/deep/ .van-tab--active {
  font-family: PingFangSC-Regular;
  font-size: 1.4rem;
  color: #a9936b !important;
  letter-spacing: 0;
  text-align: center;
}
/deep/ .van-tabs--line .van-tabs__wrap {
  position: fixed;
  width: 100%;
  z-index: 12;
}
.has-comments {
  padding: 0 1.5rem 1.5rem;
  background: #fff;
  margin: 1.3rem 0 0;
  .has-comments-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 7.6rem;
    .user-tx {
      height: 3.2rem;
      width: 3.2rem;
      border-radius: 100%;
    }
    .user-box {
      flex: 1;
      text-align: left;
      margin-left: 1rem;
      .user-name {
        font-family: PingFangSC-Semibold;
        font-size: 1.4rem;
        color: #424242;
        line-height: 1.4rem;
        font-weight: 600;
        line-height: 1.8rem;
      }
    }

    .update-time {
      opacity: 0.5;
      font-family: PingFangSC-Regular;
      font-size: 1.2rem;
      color: #424242;
      text-align: right;
      line-height: 1.2rem;
    }
  }
  .content-pic {
    width: 30%;
    height: auto;
  }
  .comment-content {
    text-align: left;
    font-family: PingFangSC-Regular;
    font-size: 1.4rem;
    color: #424242;
    text-align: justify;
    line-height: 1.8rem;
    margin: 1.5rem 0 1rem;
  }
  .goodsCell {
    width: 100%;
    padding: 1.6rem 1.2rem;
    background: #fafafa;
    border-radius: 8px;
    margin-bottom: 0;
    /deep/ .van-card {
      background: #fafafa;
    }
    /deep/ .van-image__img {
      border-radius: 5px;
    }
  }
}
.no-data {
  opacity: 0.5;
  font-family: PingFangSC-Regular;
  font-size: 1.4rem;
  color: #424242;
  letter-spacing: 0;
  line-height: 1.6rem;
}
</style>



// WEBPACK FOOTER //
// src/view/person/myorders.vue